import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import VolcanSidebar from "../components/menu/VolcanSidebar";
import { useVolcanSidebarLayout } from "../../hooks/useVolcanSidebarLayout";
import {
  getVolcanDescripcionById,
  getLineaTiempoPorVolcan,
  getEventoDetalleAmpliado,
} from "../services/volcanService";
import { getMediaUrl } from "../../utils/api";
import "./VolcanDetail.css";
import "./EventoDetalle.css";
import "../components/documentos/VolcanDocumentos.css";
import pdfIcon from "../../assets/images/ui/descarga_pdf.png";
import { normalizeAdminRichText } from "../../utils/richText";
import { formatLugaresColombiaDisplay } from "../../utils/geoDisplayFormat";
import excelIcon from "../../assets/images/ui/descarga_excel.png";
import bannerImg from "../../assets/images/ui/banner.png";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import MediaCarousel from "../components/evento_detalle/MediaCarousel";
import EventoTopNav from "../components/evento_detalle/EventoTopNav";
import {
  normalizeArray,
  pickTextOrHtml,
  formatFechaEventoResumen,
  getEventoTituloSinPrefijoFecha,
  pickEventoImagenPath,
  tipoEventoParaMasthead,
  parseDatosGeologicos,
  splitRichTextBlocks,
  parseGeneralidadFieldWithSources,
  parseEstiloEruptivoField,
  expandVeiDisplayValues,
  buildGeneralidadesFuentesHtml,
  getEventoNavSectionsWithContent,
  defaultSubForEventoSection,
} from "../components/evento_detalle/eventoDetalleUtils";
import { normalizeProductosEruptivosList } from "../components/evento_detalle/parametrosTipoConfig";
import { formatTipoTabLabelLines } from "../components/evento_detalle/EvtTipoTabLabel";
import {
  EVENTO_NAV_SECTIONS,
  EVENTO_TIPO_LINEA_LABEL,
  EVENTO_TIPO_COLORS,
  eventoTipoBadgeTextColor,
  EVENTO_EMPTY_MESSAGES,
} from "../components/evento_detalle/eventoDetalleConstants";
import TablaParametrosEruptivos from "../components/evento_detalle/TablaParametrosEruptivos";
import TablaFenomenosAsociados from "../components/evento_detalle/TablaFenomenosAsociados";
import EvtEfectosTipoTabs from "../components/evento_detalle/EvtEfectosTipoTabs";
import {
  efectoBelongsToTipo,
  getEfectoTiposConDatos,
} from "../components/evento_detalle/efectosTipoConfig";

function TablaDocumentosRelacionados({ rows }) {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const sortedData = useMemo(() => {
    const base = (rows || []).map((doc, originalIndex) => ({
      ...doc,
      __originalIndex: originalIndex,
    }));

    if (!sortConfig.key) return base;

    const sorted = [...base].sort((a, b) => {
      if (sortConfig.key === "__index") {
        return sortConfig.direction === "asc"
          ? a.__originalIndex - b.__originalIndex
          : b.__originalIndex - a.__originalIndex;
      }

      const aValue = String(a?.[sortConfig.key] ?? "").toLowerCase();
      const bValue = String(b?.[sortConfig.key] ?? "").toLowerCase();
      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });

    return sorted;
  }, [rows, sortConfig]);

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const getArrow = (key) => {
    if (sortConfig.key !== key) return " ↕";
    return sortConfig.direction === "asc" ? " ↑" : " ↓";
  };

  if (!rows || rows.length === 0) return null;

  return (
    <div className="tabla-container">
      <table className="tabla-documentos tabla-documentos--evento">
        <thead>
          <tr>
            <th style={{ width: "70px" }} onClick={() => handleSort("__index")}>
              <div className="th-content">
                <span>#</span>
              </div>
            </th>
            <th onClick={() => handleSort("tipo_fuente")}>
              <div className="th-content">
                <span>Tipo de fuente</span>
                <span>{getArrow("tipo_fuente")}</span>
              </div>
            </th>
            <th onClick={() => handleSort("tipologia")}>
              <div className="th-content">
                <span>Tipología</span>
                <span>{getArrow("tipologia")}</span>
              </div>
            </th>
            <th onClick={() => handleSort("referencia_bibliografica")}>
              <div className="th-content">
                <span>Referencia bibliográfica</span>
                <span>{getArrow("referencia_bibliografica")}</span>
              </div>
            </th>
            <th>
              <div className="th-content">
                <span>Documento original</span>
              </div>
            </th>
            <th>
              <div className="th-content">
                <span>Transcripción</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((doc, index) => (
            <tr key={doc?.id ?? index}>
              <td data-label="#">{index + 1}</td>
              <td data-label="Tipo de fuente">{doc?.tipo_fuente ?? "—"}</td>
              <td data-label="Tipología">{doc?.tipologia ?? "—"}</td>
              <td data-label="Referencia bibliográfica">
                {doc?.referencia_bibliografica ?? "—"}
              </td>
              <td data-label="Descarga original" className="evt-pdf-cell">
                {doc?.pdf_original ? (
                  <a
                    className="evt-pdf-link"
                    href={getMediaUrl(doc.pdf_original)}
                    target="_blank"
                    rel="noreferrer"
                    download
                    aria-label="Descargar PDF original"
                    data-sgc-tooltip="Descargar PDF original"
                  >
                    <img className="evt-pdf-img" src={pdfIcon} alt="" />
                  </a>
                ) : null}
              </td>
              <td data-label="Transcripción" className="evt-pdf-cell">
                {doc?.transcripcion ? (
                  <a
                    className="evt-pdf-link"
                    href={getMediaUrl(doc.transcripcion)}
                    target="_blank"
                    rel="noreferrer"
                    download
                    aria-label="Descargar transcripción"
                    data-sgc-tooltip="Descargar transcripción"
                  >
                    <img className="evt-pdf-img" src={pdfIcon} alt="" />
                  </a>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function TablaEfectos({ rows }) {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const sortedData = useMemo(() => {
    const base = (rows || []).map((e, originalIndex) => ({
      ...e,
      __originalIndex: originalIndex,
    }));

    if (!sortConfig.key) return base;

    const sorted = [...base].sort((a, b) => {
      if (sortConfig.key === "__index") {
        return sortConfig.direction === "asc"
          ? a.__originalIndex - b.__originalIndex
          : b.__originalIndex - a.__originalIndex;
      }

      const aValue = String(a?.[sortConfig.key] ?? "").toLowerCase();
      const bValue = String(b?.[sortConfig.key] ?? "").toLowerCase();
      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });

    return sorted;
  }, [rows, sortConfig]);

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const getArrow = (key) => {
    if (sortConfig.key !== key) return " ↕";
    return sortConfig.direction === "asc" ? " ↑" : " ↓";
  };

  if (!rows || rows.length === 0) return null;

  return (
    <div className="tabla-container">
      <table className="tabla-documentos tabla-documentos--efectos">
        <thead>
          <tr>
            <th style={{ width: "70px" }} onClick={() => handleSort("__index")}>
              <div className="th-content">
                <span>#</span>
              </div>
            </th>
            <th onClick={() => handleSort("descripcion_efecto")}>
              <div className="th-content">
                <span>Efecto</span>
                <span>{getArrow("descripcion_efecto")}</span>
              </div>
            </th>
            <th onClick={() => handleSort("documento")}>
              <div className="th-content">
                <span>Fuente original</span>
                <span>{getArrow("documento")}</span>
              </div>
            </th>
            <th onClick={() => handleSort("sitios_afectados")}>
              <div className="th-content">
                <span>Sitios afectados</span>
                <span>{getArrow("sitios_afectados")}</span>
              </div>
            </th>
            <th onClick={() => handleSort("sitio_reporte")}>
              <div className="th-content">
                <span>Sitio de reporte</span>
                <span>{getArrow("sitio_reporte")}</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((e, index) => (
            <tr key={e?.id ?? index}>
              <td data-label="#">{index + 1}</td>
              <td data-label="Efecto">
                {e?.descripcion_efecto || e?.descripcion ? (
                  <div
                    className="rich-text evt-html evt-html--tight"
                    dangerouslySetInnerHTML={{
                      __html: normalizeAdminRichText(
                        e?.descripcion_efecto ?? e?.descripcion ?? "",
                      ),
                    }}
                  />
                ) : (
                  "—"
                )}
              </td>
              <td data-label="Fuente original">{e?.documento ?? "—"}</td>
              <td data-label="Sitios afectados">
                {formatLugaresColombiaDisplay(e?.sitios_afectados) || "—"}
              </td>
              <td data-label="Sitio de reporte">
                {formatLugaresColombiaDisplay(e?.sitio_reporte) || "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function TablaReferenciasEspecializadas({ rows }) {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const sortedData = useMemo(() => {
    const base = (rows || []).map((doc, originalIndex) => ({
      ...doc,
      __originalIndex: originalIndex,
    }));

    if (!sortConfig.key) return base;

    const sorted = [...base].sort((a, b) => {
      if (sortConfig.key === "__index") {
        return sortConfig.direction === "asc"
          ? a.__originalIndex - b.__originalIndex
          : b.__originalIndex - a.__originalIndex;
      }

      const aValue = String(a?.[sortConfig.key] ?? "").toLowerCase();
      const bValue = String(b?.[sortConfig.key] ?? "").toLowerCase();
      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });

    return sorted;
  }, [rows, sortConfig]);

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const getArrow = (key) => {
    if (sortConfig.key !== key) return " ↕";
    return sortConfig.direction === "asc" ? " ↑" : " ↓";
  };

  if (!rows || rows.length === 0) return null;

  return (
    <div className="tabla-container">
      <table className="tabla-documentos tabla-documentos--referencias">
        <thead>
          <tr>
            <th style={{ width: "70px" }} onClick={() => handleSort("__index")}>
              <div className="th-content">
                <span>#</span>
              </div>
            </th>
            <th onClick={() => handleSort("tipologia")}>
              <div className="th-content">
                <span>Tipología</span>
                <span>{getArrow("tipologia")}</span>
              </div>
            </th>
            <th onClick={() => handleSort("referencia_bibliografica")}>
              <div className="th-content">
                <span>Referencia bibliográfica</span>
                <span>{getArrow("referencia_bibliografica")}</span>
              </div>
            </th>
            <th>
              <div className="th-content">
                <span>
                  Documento
                  <br />
                  original
                </span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((doc, index) => {
            const ref =
              doc?.referencia_bibliografica ??
              doc?.referencia ??
              doc?.titulo ??
              doc?.cita ??
              "—";

            const file =
              doc?.documento_original ??
              doc?.pdf_original ??
              doc?.documento ??
              doc?.archivo ??
              null;

            return (
              <tr key={doc?.id ?? index}>
                <td data-label="#">{index + 1}</td>
                <td data-label="Tipología">{doc?.tipologia ?? "—"}</td>
                <td data-label="Referencia bibliográfica">{ref}</td>
                <td data-label="Documento original" className="evt-pdf-cell">
                  {file ? (
                    <a
                      className="evt-pdf-link"
                      href={getMediaUrl(file)}
                      target="_blank"
                      rel="noreferrer"
                      download
                      aria-label="Descargar documento original"
                      data-sgc-tooltip="Descargar documento original"
                    >
                      <img className="evt-pdf-img" src={pdfIcon} alt="" />
                    </a>
                  ) : null}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function renderArbolFuentesNode(node, depth = 0) {
  if (node == null) return null;
  if (typeof node === "string") {
    const looksHtml = /<\/?[a-z][\s\S]*>/i.test(node);
    if (looksHtml) {
      return (
        <div
          className="descripcion-texto evt-html evt-arbol-html"
          style={{ textAlign: "justify", marginLeft: depth * 14 }}
          dangerouslySetInnerHTML={{ __html: node }}
        />
      );
    }
    return (
      <p className="evt-arbol-line" style={{ marginLeft: depth * 14 }}>
        {node}
      </p>
    );
  }
  if (Array.isArray(node)) {
    return (
      <ul
        className={`evt-arbol-list${depth === 0 ? " evt-arbol-list--root" : ""}`}
      >
        {node.map((item, i) => (
          <li key={i}>{renderArbolFuentesNode(item, depth + 1)}</li>
        ))}
      </ul>
    );
  }
  if (typeof node === "object") {
    const label =
      node.titulo ??
      node.label ??
      node.nombre ??
      node.name ??
      node.texto ??
      node.descripcion ??
      null;
    const children =
      node.hijos ?? node.children ?? node.fuentes ?? node.nodos ?? null;
    return (
      <div className="evt-arbol-node" style={{ marginLeft: depth * 14 }}>
        {label != null && String(label).trim() !== "" ? (
          <div className="evt-arbol-label">{String(label)}</div>
        ) : null}
        {children ? renderArbolFuentesNode(children, depth + 1) : null}
      </div>
    );
  }
  return <span className="evt-arbol-line">{String(node)}</span>;
}

function PanelGeneralidades({ evento }) {
  const gen = useMemo(() => {
    return (
      (evento?.generalidades && typeof evento.generalidades === "object"
        ? evento.generalidades
        : null) ?? {}
    );
  }, [evento]);

  const hora = String(gen?.hora ?? "").trim();
  const tipoActividadRaw = String(gen?.tipo_actividad ?? "").trim();
  const tipoActividadParsed = useMemo(
    () => parseGeneralidadFieldWithSources(tipoActividadRaw),
    [tipoActividadRaw],
  );
  const tipoActividad = tipoActividadParsed.displayText;
  const estiloEruptivoRaw = String(gen?.estilo_eruptivo ?? "").trim();
  const estiloEruptivoParsed = useMemo(
    () => parseEstiloEruptivoField(estiloEruptivoRaw),
    [estiloEruptivoRaw],
  );
  const estiloEruptivoLineas = estiloEruptivoParsed.displayValues;
  const municipiosRaw = String(gen?.municipios_afectados ?? "").trim();
  const municipiosDisplay = municipiosRaw
    ? formatLugaresColombiaDisplay(municipiosRaw) || municipiosRaw
    : "";
  const veiRaw = String(
    gen?.indice_vei ?? gen?.vei_valor ?? gen?.vei ?? "",
  ).trim();
  const veiParsed = useMemo(
    () => parseGeneralidadFieldWithSources(veiRaw),
    [veiRaw],
  );
  const veiValues = useMemo(
    () => expandVeiDisplayValues(veiParsed.displayValues),
    [veiParsed],
  );
  const fuentesHtml = useMemo(
    () =>
      buildGeneralidadesFuentesHtml({
        tipoActividadRaw,
        veiRaw,
        estiloEruptivoRaw,
        fuentesRaw: gen?.fuentes,
      }),
    [tipoActividadRaw, veiRaw, estiloEruptivoRaw, gen?.fuentes],
  );

  const resumenTexto = String(gen?.resumen ?? evento?.resumen ?? "").trim();
  const resumenHtml = useMemo(
    () => normalizeAdminRichText(resumenTexto),
    [resumenTexto],
  );
  const municipiosHtml = useMemo(
    () => normalizeAdminRichText(municipiosDisplay),
    [municipiosDisplay],
  );
  const productos = useMemo(() => normalizeProductosEruptivosList(gen), [gen]);
  const explicacionBlocks = useMemo(() => {
    const raw = String(gen?.explicacion_productos ?? "").trim();
    return splitRichTextBlocks(raw);
  }, [gen]);

  return (
    <div className="evt-gen-board">
      <div className="evt-gen-upper">
        <div className="evt-gen-left-col">
          <div className="evt-gen-mini-grid">
            <div className="evt-gen-card evt-gen-card--mini evt-gen-card--hora">
              <i className="bi bi-clock" aria-hidden />
              <span>
                <strong>Hora:</strong> {hora || "—"}
              </span>
            </div>

            <div className="evt-gen-card evt-gen-card--mini evt-gen-card--center">
              <h3 className="evt-gen-card-title">Tipo de Actividad</h3>
              <p className="evt-gen-card-value">{tipoActividad || "—"}</p>
            </div>

            <div className="evt-gen-card evt-gen-card--mini evt-gen-card--center evt-gen-card--sitios">
              <h3 className="evt-gen-card-title">Sitios afectados</h3>
              {municipiosDisplay ? (
                <div
                  className="evt-gen-card-value rich-text evt-html evt-html--tight"
                  dangerouslySetInnerHTML={{ __html: municipiosHtml }}
                />
              ) : (
                <p className="evt-gen-card-value">—</p>
              )}
            </div>

            <div className="evt-gen-card evt-gen-card--mini evt-gen-card--vei">
              <h3 className="evt-gen-card-title">
                Índice de Explosividad Volcánica (VEI)
              </h3>
              <div
                className="evt-gen-vei-bar"
                role="img"
                aria-label={
                  veiValues.length
                    ? `Índice de explosividad volcánica: ${veiValues.join(", ")}`
                    : "Escala del índice de explosividad volcánica"
                }
              >
                {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
                  <span
                    key={n}
                    className={`evt-gen-vei-seg evt-gen-vei-seg--${n}${
                      veiValues.includes(n) ? " is-active" : ""
                    }`}
                    aria-hidden={veiValues.includes(n) ? undefined : true}
                  >
                    {veiValues.includes(n) ? n : ""}
                  </span>
                ))}
              </div>
            </div>

            <div className="evt-gen-card evt-gen-card--mini evt-gen-card--center">
              <h3 className="evt-gen-card-title">Estilo eruptivo</h3>
              {estiloEruptivoLineas.length > 0 ? (
                <div className="evt-gen-card-value evt-gen-card-value--lines">
                  {estiloEruptivoLineas.map((linea, index) => (
                    <span key={index} className="evt-gen-card-value-line">
                      {linea}
                    </span>
                  ))}
                </div>
              ) : (
                <p className="evt-gen-card-value">—</p>
              )}
            </div>

            <div className="evt-gen-card evt-gen-card--mini evt-gen-card--productos">
              <h3 className="evt-gen-card-title">Productos eruptivos</h3>
              {productos.length > 0 ? (
                <ul
                  className={`evt-gen-productos-list evt-gen-productos-list--count-${Math.min(productos.length, 7)}`}
                >
                  {productos.map((producto, index) => {
                    const labelLines = formatTipoTabLabelLines(producto.nombre);
                    return (
                      <li
                        key={producto.clave || producto.nombre || index}
                        className="evt-gen-producto-item"
                      >
                        <span className="evt-gen-producto-icon-wrap">
                          {producto.icon ? (
                            <img
                              src={producto.icon}
                              alt=""
                              className="evt-gen-producto-icon"
                              aria-hidden
                            />
                          ) : (
                            <span
                              className="evt-gen-producto-icon evt-gen-producto-icon--empty"
                              aria-hidden
                            />
                          )}
                        </span>
                        <span
                          className={`evt-gen-producto-label${
                            labelLines.length > 1
                              ? " evt-gen-producto-label--multiline"
                              : ""
                          }`}
                        >
                          {labelLines.length > 1
                            ? labelLines.map((line, lineIdx) => (
                                <span
                                  key={`${line}-${lineIdx}`}
                                  className="evt-gen-producto-label-line"
                                >
                                  {line}
                                </span>
                              ))
                            : labelLines[0] || producto.nombre}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <p className="evt-gen-card-value">—</p>
              )}
            </div>
          </div>

          <section className="evt-gen-card evt-gen-card--explicacion">
            <h3 className="evt-gen-card-title evt-gen-card-title--left">
              Explicación productos eruptivos
            </h3>
            {explicacionBlocks.length > 0 ? (
              <ol className="evt-gen-expl-list">
                {explicacionBlocks.map((block, index) => (
                  <li key={index} className="evt-gen-expl-item">
                    <div
                      className="rich-text evt-html evt-html--tight"
                      dangerouslySetInnerHTML={{ __html: block }}
                    />
                  </li>
                ))}
              </ol>
            ) : (
              <div className="evt-empty">—</div>
            )}
          </section>
        </div>

        <aside className="evt-gen-card evt-gen-card--resumen">
          <h3 className="evt-gen-card-title evt-gen-card-title--resumen">
            Resumen
          </h3>
          {resumenTexto ? (
            <div
              className="rich-text evt-gen-resumen-text evt-html evt-html--tight"
              dangerouslySetInnerHTML={{ __html: resumenHtml }}
            />
          ) : (
            <div className="evt-empty">{EVENTO_EMPTY_MESSAGES.resumen}</div>
          )}
        </aside>
      </div>

      <section className="evt-gen-card evt-gen-card--fuentes">
        <h3 className="evt-gen-fuentes-title">Fuentes:</h3>
        {fuentesHtml ? (
          <div
            className="rich-text evt-html evt-html--tight"
            dangerouslySetInnerHTML={{ __html: fuentesHtml }}
          />
        ) : (
          <p className="evt-gen-fuentes-empty">—</p>
        )}
      </section>
    </div>
  );
}

function PanelInformacionHistorica({
  evento,
  subTab,
  volcanTitle,
  eventoTitle,
}) {
  const DEFAULT_ARBOL_ZOOM = 1;
  const ih =
    evento?.informacion_historica ??
    evento?.info_historica ??
    evento?.historico ??
    {};

  const generalidadesHtml = pickTextOrHtml(ih?.generalidades) || "";
  const imagenArbolFuentes =
    ih?.imagen_arbol_fuentes ??
    ih?.imagenArbolFuentes ??
    ih?.imagen_arbol ??
    null;
  const arbolRaw =
    ih?.arbol_fuentes ?? ih?.arbol_de_fuentes ?? ih?.arbolFuentes ?? null;
  const efectos = normalizeArray(ih?.efectos);
  const resumenEfectos = String(
    ih?.resumen_efectos ?? ih?.resumenEfectos ?? "",
  ).trim();
  const resumenEfectosHtml = useMemo(
    () => normalizeAdminRichText(resumenEfectos),
    [resumenEfectos],
  );

  const [tipoEfectoSel, setTipoEfectoSel] = useState(null);
  const [excelBusy, setExcelBusy] = useState(false);
  const [arbolZoom, setArbolZoom] = useState(DEFAULT_ARBOL_ZOOM);
  const [arbolPan, setArbolPan] = useState({ x: 0, y: 0 });
  const [arbolIsPanning, setArbolIsPanning] = useState(false);
  const arbolPanStartRef = useRef({ x: 0, y: 0, panX: 0, panY: 0 });
  const arbolIsPanningRef = useRef(false);
  const arbolZoomExpanded = arbolZoom > DEFAULT_ARBOL_ZOOM;
  const [arbolDownloadBusy, setArbolDownloadBusy] = useState(false);

  const efectoTiposDisponibles = useMemo(
    () => getEfectoTiposConDatos(efectos),
    [efectos],
  );

  useEffect(() => {
    if (subTab !== "efectos") return;
    setTipoEfectoSel((prev) => {
      if (efectoTiposDisponibles.some((item) => item.label === prev)) {
        return prev;
      }
      return efectoTiposDisponibles[0]?.label ?? null;
    });
  }, [subTab, efectoTiposDisponibles]);

  const efectosFiltrados = useMemo(() => {
    if (!tipoEfectoSel) return [];
    return efectos.filter((e) => efectoBelongsToTipo(e, tipoEfectoSel));
  }, [efectos, tipoEfectoSel]);

  const documentosRelacionados = normalizeArray(
    ih?.documentos_relacionados ?? ih?.documentosRelacionados ?? ih?.documentos,
  );

  const tieneArbolFuentes = useMemo(() => {
    if (imagenArbolFuentes) return true;
    if (arbolRaw != null) {
      if (typeof arbolRaw === "object") {
        if (Array.isArray(arbolRaw)) return arbolRaw.length > 0;
        return Object.keys(arbolRaw).length > 0;
      }
      if (String(arbolRaw).trim()) return true;
    }
    if (pickTextOrHtml(arbolRaw)) return true;
    if (generalidadesHtml) return true;
    return false;
  }, [imagenArbolFuentes, arbolRaw, generalidadesHtml]);

  const eventoTitleSafe = String(eventoTitle ?? "").trim();

  const arbolImageUrl = useMemo(() => {
    if (!imagenArbolFuentes) return "";
    return getMediaUrl(imagenArbolFuentes);
  }, [imagenArbolFuentes]);

  useEffect(() => {
    if (subTab !== "arbol_fuentes") return;
    setArbolZoom(DEFAULT_ARBOL_ZOOM);
    setArbolPan({ x: 0, y: 0 });
  }, [subTab, arbolImageUrl]);

  useEffect(() => {
    if (arbolZoom <= DEFAULT_ARBOL_ZOOM) setArbolPan({ x: 0, y: 0 });
  }, [arbolZoom]);

  useEffect(() => {
    if (!arbolZoomExpanded) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setArbolZoom(DEFAULT_ARBOL_ZOOM);
    };
    window.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [arbolZoomExpanded]);

  const handleArbolPanStart = (e) => {
    if (!arbolZoomExpanded) return;
    e.preventDefault();
    e.currentTarget.setPointerCapture(e.pointerId);
    arbolPanStartRef.current = {
      x: e.clientX,
      y: e.clientY,
      panX: arbolPan.x,
      panY: arbolPan.y,
    };
    arbolIsPanningRef.current = true;
    setArbolIsPanning(true);
  };

  const handleArbolPanMove = (e) => {
    if (!arbolIsPanningRef.current) return;
    e.preventDefault();
    const dx = e.clientX - arbolPanStartRef.current.x;
    const dy = e.clientY - arbolPanStartRef.current.y;
    setArbolPan({
      x: arbolPanStartRef.current.panX + dx,
      y: arbolPanStartRef.current.panY + dy,
    });
  };

  const handleArbolPanEnd = (e) => {
    if (!arbolIsPanningRef.current) return;
    if (e.currentTarget.hasPointerCapture?.(e.pointerId)) {
      e.currentTarget.releasePointerCapture(e.pointerId);
    }
    arbolIsPanningRef.current = false;
    setArbolIsPanning(false);
  };

  const downloadArbolFuentes = useCallback(async () => {
    if (!arbolImageUrl) return;
    try {
      setArbolDownloadBusy(true);
      const resp = await fetch(arbolImageUrl, { mode: "cors" });
      if (!resp.ok) throw new Error("fetch_failed");
      const blob = await resp.blob();
      const extGuess = (() => {
        const ct = String(resp.headers.get("content-type") ?? "").toLowerCase();
        if (ct.includes("png")) return "png";
        if (ct.includes("jpeg") || ct.includes("jpg")) return "jpg";
        if (ct.includes("webp")) return "webp";
        if (ct.includes("svg")) return "svg";
        const u = arbolImageUrl.split("?")[0].toLowerCase();
        const m = u.match(/\.(png|jpe?g|webp|svg)$/);
        return m ? m[1] : "png";
      })();
      const base =
        eventoTitleSafe.replace(/[\\/:*?"<>|]+/g, " ").trim() ||
        `evento_${String(evento?.id ?? "arbol")}`;
      saveAs(blob, `arbol_fuentes_${base}.${extGuess}`);
    } catch {
      window.open(arbolImageUrl, "_blank", "noopener,noreferrer");
    } finally {
      setArbolDownloadBusy(false);
    }
  }, [arbolImageUrl, eventoTitleSafe, evento?.id]);

  function htmlToPlainText(value) {
    if (value == null) return "";
    const s = String(value);
    if (!s.trim()) return "";
    if (!/[<>]/.test(s)) return s.trim();
    try {
      const doc = new DOMParser().parseFromString(s, "text/html");
      return String(doc?.body?.textContent ?? "")
        .replace(/\s+/g, " ")
        .trim();
    } catch {
      return s
        .replace(/<[^>]*>/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    }
  }

  function safeSheetName(name, used) {
    const base =
      String(name ?? "")
        .trim()
        .replace(new RegExp("[\\[\\]*/\\\\?:]", "g"), " ")
        .replace(/\s+/g, " ")
        .trim()
        .slice(0, 31) || "Efectos";
    if (!used.has(base)) {
      used.add(base);
      return base;
    }
    for (let i = 2; i < 100; i += 1) {
      const suffix = ` (${i})`;
      const candidate = (base.slice(0, 31 - suffix.length) + suffix).slice(
        0,
        31,
      );
      if (!used.has(candidate)) {
        used.add(candidate);
        return candidate;
      }
    }
    return base.slice(0, 31);
  }

  async function downloadEfectosExcel() {
    const wb = new ExcelJS.Workbook();
    wb.creator = "Servicio Geológico Colombiano";
    wb.created = new Date();

    const byTipo = new Map();
    (efectos || []).forEach((e) => {
      const t = String(e?.tipo_efecto ?? e?.tipo ?? "—").trim() || "—";
      if (!byTipo.has(t)) byTipo.set(t, []);
      byTipo.get(t).push(e);
    });

    const usedNames = new Set();
    const tipos = Array.from(byTipo.keys()).sort((a, b) =>
      a.localeCompare(b, "es"),
    );

    const bannerBuf = await fetch(bannerImg).then((r) => r.arrayBuffer());
    const bannerId = wb.addImage({ buffer: bannerBuf, extension: "png" });

    tipos.forEach((tipo) => {
      const sheetName = safeSheetName(tipo, usedNames);
      const ws = wb.addWorksheet(sheetName, {
        properties: { defaultRowHeight: 18 },
        views: [{ state: "frozen", ySplit: 7 }],
      });

      // Columnas: ID, DESCRIPCIÓN, FUENTE ORIGINAL, SITIOS AFECTADOS, SITIO DE REPORTE
      ws.getColumn(1).width = 10; // ID
      ws.getColumn(2).width = 54; // Descripción
      ws.getColumn(3).width = 26; // Fuente
      ws.getColumn(4).width = 28; // Sitios afectados
      ws.getColumn(5).width = 24; // Sitio de reporte

      // Banner A1:E3
      ws.getRow(1).height = 26;
      ws.getRow(2).height = 26;
      ws.getRow(3).height = 26;
      ws.addImage(bannerId, {
        tl: { col: 0, row: 0 },
        br: { col: 5, row: 3 },
        editAs: "oneCell",
      });

      // Título
      ws.mergeCells("A4:E4");
      ws.getCell("A4").value = `Reporte de efectos (Volcán: ${
        String(volcanTitle ?? "").trim() || "—"
      } | Evento: ${eventoTitleSafe || "—"})`;
      ws.getCell("A4").font = {
        bold: true,
        color: { argb: "FF1E4D2B" },
        size: 11,
      };
      ws.getCell("A4").alignment = { vertical: "middle", horizontal: "center" };
      ws.getRow(4).height = 20;

      ws.mergeCells("A5:E5");
      ws.getCell("A5").value = `Tipo de efecto: ${tipo}`;
      ws.getCell("A5").font = {
        bold: true,
        color: { argb: "FF005833" },
        size: 10,
      };
      ws.getCell("A5").alignment = { vertical: "middle", horizontal: "center" };
      ws.getRow(5).height = 18;

      ws.mergeCells("A6:E6");
      ws.getCell("A6").value =
        `Generado: ${new Date().toLocaleString("es-CO")}`;
      ws.getCell("A6").font = { color: { argb: "FF646464" }, size: 10 };
      ws.getCell("A6").alignment = { vertical: "middle", horizontal: "center" };
      ws.getRow(6).height = 18;

      // Cabecera tabla (fila 7)
      const headerRow = ws.addRow([
        "ID",
        "DESCRIPCIÓN",
        "FUENTE ORIGINAL",
        "SITIOS AFECTADOS",
        "SITIO DE REPORTE",
      ]);
      headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
      headerRow.alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
      headerRow.height = 28;
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF005833" },
        };
        cell.border = {
          top: { style: "thin", color: { argb: "FFBFC9C2" } },
          left: { style: "thin", color: { argb: "FFBFC9C2" } },
          bottom: { style: "thin", color: { argb: "FFBFC9C2" } },
          right: { style: "thin", color: { argb: "FFBFC9C2" } },
        };
      });

      // Filas
      const rows = byTipo.get(tipo) || [];
      rows.forEach((e) => {
        const id = e?.id ?? "—";
        const descripcion =
          htmlToPlainText(e?.descripcion_efecto ?? e?.descripcion) || "—";
        const fuente = String(e?.documento ?? "—").trim() || "—";
        const sitios = formatLugaresColombiaDisplay(e?.sitios_afectados) || "—";
        const reporte = formatLugaresColombiaDisplay(e?.sitio_reporte) || "—";
        const r = ws.addRow([id, descripcion, fuente, sitios, reporte]);
        r.alignment = { vertical: "top", wrapText: true };
        r.getCell(1).alignment = { vertical: "top", horizontal: "center" };
        r.getCell(2).alignment = {
          vertical: "top",
          horizontal: "left",
          wrapText: true,
        };
        r.getCell(3).alignment = {
          vertical: "top",
          horizontal: "left",
          wrapText: true,
        };
        r.getCell(4).alignment = {
          vertical: "top",
          horizontal: "left",
          wrapText: true,
        };
        r.getCell(5).alignment = {
          vertical: "top",
          horizontal: "left",
          wrapText: true,
        };
        r.eachCell((cell) => {
          cell.border = {
            top: { style: "thin", color: { argb: "FFE0E4E5" } },
            left: { style: "thin", color: { argb: "FFE0E4E5" } },
            bottom: { style: "thin", color: { argb: "FFE0E4E5" } },
            right: { style: "thin", color: { argb: "FFE0E4E5" } },
          };
        });
      });
    });

    const buf = await wb.xlsx.writeBuffer();
    saveAs(
      new Blob([buf], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      "reporte_efectos.xlsx",
    );
  }

  return (
    <div className="evt-panel-stack">
      {subTab === "documentos" ? (
        <section className="evt-card evt-card--table-embed">
          <h4 className="evt-card-title">Documentos históricos</h4>
          {documentosRelacionados.length === 0 ? (
            <div className="evt-empty">{EVENTO_EMPTY_MESSAGES.documentos}</div>
          ) : (
            <TablaDocumentosRelacionados rows={documentosRelacionados} />
          )}
        </section>
      ) : null}

      {subTab === "arbol_fuentes" ? (
        <section className="evt-card">
          <h4 className="evt-card-title">Árbol de fuentes</h4>
          {!tieneArbolFuentes ? (
            <div className="evt-empty">
              {EVENTO_EMPTY_MESSAGES.arbol_fuentes}
            </div>
          ) : null}
          {imagenArbolFuentes ? (
            <div
              className={`evt-arbol-viewer${arbolZoomExpanded ? " evt-arbol-viewer--zoomed" : ""}`}
            >
              {arbolZoomExpanded ? (
                <div
                  className="evt-media-zoom-layer"
                  role="dialog"
                  aria-modal="true"
                  aria-label="Árbol de fuentes ampliado"
                >
                  <button
                    type="button"
                    className="evt-media-zoom-layer-close"
                    onClick={() => setArbolZoom(DEFAULT_ARBOL_ZOOM)}
                    aria-label="Cerrar vista ampliada"
                  >
                    ×
                  </button>
                  <div
                    className={`evt-media-zoom-layer-stage${arbolIsPanning ? " evt-media-zoom-layer-stage--dragging" : ""}`}
                    onPointerDown={handleArbolPanStart}
                    onPointerMove={handleArbolPanMove}
                    onPointerUp={handleArbolPanEnd}
                    onPointerCancel={handleArbolPanEnd}
                  >
                    <img
                      className="evt-media-img evt-media-img--zoom-layer"
                      src={arbolImageUrl}
                      alt="Árbol de fuentes"
                      draggable={false}
                      style={{
                        transform: `translate(${arbolPan.x}px, ${arbolPan.y}px) scale(${arbolZoom})`,
                        transformOrigin: "center center",
                      }}
                    />
                  </div>
                </div>
              ) : null}
              <div className="evt-arbol-image">
                <div
                  className="evt-arbol-toolbar"
                  role="toolbar"
                  aria-label="Controles del árbol de fuentes"
                >
                  <div className="evt-arbol-zoom" aria-label="Zoom">
                    <button
                      type="button"
                      className="evt-arbol-btn"
                      onClick={() =>
                        setArbolZoom((z) =>
                          Math.max(0.5, Math.round((z - 0.1) * 10) / 10),
                        )
                      }
                      aria-label="Alejar"
                      data-sgc-tooltip="Alejar"
                    >
                      −
                    </button>
                    <span className="evt-arbol-zoom-value" aria-live="polite">
                      {Math.round(arbolZoom * 100)}%
                    </span>
                    <button
                      type="button"
                      className="evt-arbol-btn"
                      onClick={() =>
                        setArbolZoom((z) =>
                          Math.min(2.5, Math.round((z + 0.1) * 10) / 10),
                        )
                      }
                      aria-label="Acercar"
                      data-sgc-tooltip="Acercar"
                    >
                      +
                    </button>
                    <button
                      type="button"
                      className="evt-arbol-btn evt-arbol-btn--ghost"
                      onClick={() => setArbolZoom(DEFAULT_ARBOL_ZOOM)}
                      aria-label="Restablecer zoom"
                      data-sgc-tooltip="Restablecer zoom"
                    >
                      Restablecer
                    </button>
                  </div>
                  <button
                    type="button"
                    className="evt-arbol-download"
                    onClick={downloadArbolFuentes}
                    disabled={arbolDownloadBusy}
                    aria-label="Descargar imagen del árbol de fuentes"
                    data-sgc-tooltip="Descargar imagen"
                  >
                    <i className="bi bi-download" aria-hidden />
                    <span>Descargar</span>
                  </button>
                </div>
                <div
                  className="evt-arbol-viewport"
                  aria-label="Vista del árbol de fuentes"
                >
                  <div className="evt-arbol-canvas">
                    <img
                      src={arbolImageUrl}
                      alt="Árbol de fuentes"
                      loading="lazy"
                      className="evt-arbol-img"
                      style={
                        arbolZoom < DEFAULT_ARBOL_ZOOM
                          ? {
                              transform: `scale(${arbolZoom})`,
                              transformOrigin: "center center",
                            }
                          : undefined
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {arbolRaw != null &&
          (typeof arbolRaw === "object" || Array.isArray(arbolRaw)) ? (
            <div className="evt-arbol-wrap">
              {renderArbolFuentesNode(arbolRaw)}
            </div>
          ) : pickTextOrHtml(arbolRaw) ? (
            <div
              className="descripcion-texto evt-html"
              style={{ textAlign: "justify" }}
              dangerouslySetInnerHTML={{ __html: pickTextOrHtml(arbolRaw) }}
            />
          ) : generalidadesHtml ? (
            <div
              className="descripcion-texto evt-html"
              style={{ textAlign: "justify" }}
              dangerouslySetInnerHTML={{ __html: generalidadesHtml }}
            />
          ) : null}
        </section>
      ) : null}

      {subTab === "efectos" ? (
        efectos.length === 0 ? (
          <section className="evt-card evt-card--table-embed">
            <h4 className="evt-card-title">Efectos</h4>
            <div className="evt-empty">{EVENTO_EMPTY_MESSAGES.efectos}</div>
          </section>
        ) : (
          <section className="evt-card evt-card--table-embed">
            <h4 className="evt-card-title">Efectos</h4>
            {resumenEfectos ? (
              <div className="evt-efectos-resumen">
                <div className="evt-efectos-resumen-title">
                  Resumen de efectos
                </div>
                <div
                  className="rich-text evt-efectos-resumen-text evt-html evt-html--tight"
                  dangerouslySetInnerHTML={{ __html: resumenEfectosHtml }}
                />
              </div>
            ) : null}
            <div className="evt-efectos-hero-row">
              {efectoTiposDisponibles.length > 0 ? (
                <div
                  className={`evt-efectos-tabs-card${
                    efectoTiposDisponibles.length === 1 ? " is-single-tab" : ""
                  }`}
                >
                  <EvtEfectosTipoTabs
                    items={efectoTiposDisponibles}
                    value={tipoEfectoSel}
                    onChange={setTipoEfectoSel}
                  />
                </div>
              ) : null}

              <div className="evt-efectos-filebox">
                <button
                  type="button"
                  id="evt-efectos-excel-trigger"
                  className="evt-efectos-xlsx__icon-btn evt-excel-btn"
                  data-sgc-tooltip="Descargar Excel"
                  aria-label="Descargar Excel"
                  disabled={excelBusy || efectos.length === 0}
                  onClick={async () => {
                    if (excelBusy || efectos.length === 0) return;
                    try {
                      setExcelBusy(true);
                      await downloadEfectosExcel();
                    } finally {
                      setExcelBusy(false);
                    }
                  }}
                >
                  <img src={excelIcon} alt="" />
                </button>
                <div className="evt-efectos-xlsx__meta">
                  <div className="evt-efectos-xlsx__title">
                    Archivo completo .xlsx
                  </div>
                  <button
                    type="button"
                    className="evt-efectos-xlsx__link"
                    disabled={excelBusy || efectos.length === 0}
                    aria-label="Ver y descargar archivo Excel completo"
                    onClick={() =>
                      document
                        .getElementById("evt-efectos-excel-trigger")
                        ?.click()
                    }
                  >
                    Ver y descargar
                    <i className="bi bi-box-arrow-up-right" aria-hidden />
                  </button>
                </div>
              </div>
            </div>

            {efectosFiltrados.length > 0 ? (
              <TablaEfectos rows={efectosFiltrados} />
            ) : (
              <div className="evt-empty">
                No hay datos para mostrar en {tipoEfectoSel}.
              </div>
            )}
          </section>
        )
      ) : null}
    </div>
  );
}

function PanelDatosGeologicos({ evento, subTab, volcanTitle, eventoTitle }) {
  const { parametros, fenomenos, referencias } = useMemo(
    () => parseDatosGeologicos(evento),
    [evento],
  );

  return (
    <div className="evt-panel-stack">
      {subTab === "parametros" ? (
        <TablaParametrosEruptivos
          rows={parametros}
          volcanTitle={volcanTitle}
          eventoTitle={eventoTitle}
        />
      ) : null}

      {subTab === "fenomenos" ? (
        <TablaFenomenosAsociados
          rows={fenomenos}
          volcanTitle={volcanTitle}
          eventoTitle={eventoTitle}
        />
      ) : null}

      {subTab === "referencias" ? (
        <section className="evt-card evt-card--table-embed">
          <h4 className="evt-card-title">Referencias especializadas</h4>
          {referencias.length === 0 ? (
            <div className="evt-empty">{EVENTO_EMPTY_MESSAGES.referencias}</div>
          ) : (
            <TablaReferenciasEspecializadas rows={referencias} />
          )}
        </section>
      ) : null}
    </div>
  );
}

function PanelMultimedia({ evento, subTab }) {
  const mm = evento?.multimedia ?? evento?.media ?? {};
  const imagenes = normalizeArray(mm?.imagenes ?? mm?.fotos);
  const videos = normalizeArray(mm?.videos);
  const infografias = normalizeArray(mm?.infografias ?? mm?.infografia);
  const mapas = normalizeArray(mm?.mapas ?? mm?.mapa);

  return (
    <div className="evt-panel-stack">
      {subTab === "imagenes" ? (
        <section className="evt-card">
          <h4 className="evt-card-title">Imágenes</h4>
          <MediaCarousel
            items={imagenes}
            kind="image"
            emptyLabel={EVENTO_EMPTY_MESSAGES.imagenes}
          />
        </section>
      ) : null}

      {subTab === "videos" ? (
        <section className="evt-card">
          <h4 className="evt-card-title">Videos</h4>
          <MediaCarousel
            items={videos}
            kind="video"
            emptyLabel={EVENTO_EMPTY_MESSAGES.videos}
          />
        </section>
      ) : null}

      {subTab === "infografias" ? (
        <section className="evt-card">
          <h4 className="evt-card-title">Infografías</h4>
          <MediaCarousel
            items={infografias}
            kind="image"
            emptyLabel={EVENTO_EMPTY_MESSAGES.infografias}
          />
        </section>
      ) : null}

      {subTab === "mapas" ? (
        <section className="evt-card">
          <h4 className="evt-card-title">Mapas</h4>
          <MediaCarousel
            items={mapas}
            kind="image"
            emptyLabel={EVENTO_EMPTY_MESSAGES.mapas}
          />
        </section>
      ) : null}
    </div>
  );
}

export default function EventoDetalle() {
  const [searchParams] = useSearchParams();
  const volcanId = Number(searchParams.get("volcanId"));
  const eventoId = Number(searchParams.get("eventoId"));
  const navigate = useNavigate();

  const [sidebarOpen, setSidebarOpen] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return true;
    return !window.matchMedia("(max-width: 768px)").matches;
  });
  const [activeTab] = useState("timeline");

  useVolcanSidebarLayout(sidebarOpen);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [volcanTitle, setVolcanTitle] = useState("");
  const [eventoTitle, setEventoTitle] = useState("");
  const [evento, setEvento] = useState(null);
  const [timelineMeta, setTimelineMeta] = useState(null);

  const [mainTab, setMainTab] = useState("generalidades");
  const [subIH, setSubIH] = useState("documentos");
  const [subDG, setSubDG] = useState("parametros");
  const [subMM, setSubMM] = useState("imagenes");

  useEffect(() => {
    const scrollParent = document.querySelector(".volcan-body-scroll.evt-page");
    if (!scrollParent) return;

    const STICKY_TOP_PX = 16;
    scrollParent.style.setProperty("--evt-sticky-top", `${STICKY_TOP_PX}px`);

    const updateStuck = () => {
      const parentTop = scrollParent.getBoundingClientRect().top;
      const ths = Array.from(
        scrollParent.querySelectorAll("table.tabla-documentos thead th"),
      );
      const isAnyStuck =
        ths.length > 0
          ? ths.some((th) => {
              const thTop = th.getBoundingClientRect().top;
              return thTop <= parentTop + STICKY_TOP_PX + 1;
            })
          : false;
      scrollParent.toggleAttribute("data-evt-table-stuck", isAnyStuck);
    };

    updateStuck();
    scrollParent.addEventListener("scroll", updateStuck, { passive: true });
    window.addEventListener("resize", updateStuck);
    return () => {
      scrollParent.removeEventListener("scroll", updateStuck);
      window.removeEventListener("resize", updateStuck);
    };
  }, [loading, error, eventoId, volcanId, mainTab, subIH, subDG, subMM]);

  useEffect(() => {
    if (!evento) return;

    const navSections = getEventoNavSectionsWithContent(
      evento,
      EVENTO_NAV_SECTIONS,
    );
    if (navSections.length === 0) return;

    const sectionParamRaw = searchParams.get("section");
    const subParamRaw = searchParams.get("sub");
    const sectionParam = sectionParamRaw ? String(sectionParamRaw).trim() : "";
    const subParam = subParamRaw ? String(subParamRaw).trim() : "";

    const allowedSections = new Set(navSections.map((s) => s.key));
    const requestedSection =
      sectionParam && allowedSections.has(sectionParam)
        ? sectionParam
        : navSections[0]?.key;

    if (!requestedSection) return;

    setMainTab(requestedSection);

    const section = navSections.find((s) => s.key === requestedSection);
    const children = Array.isArray(section?.children) ? section.children : [];
    if (children.length === 0) return;

    const allowedSubs = new Set(children.map((c) => c.key));
    const preferredDefault = defaultSubForEventoSection(requestedSection);
    const defaultSub = allowedSubs.has(preferredDefault)
      ? preferredDefault
      : children[0]?.key;

    const nextSub =
      subParam && allowedSubs.has(subParam) ? subParam : defaultSub;
    if (!nextSub) return;

    if (requestedSection === "informacion_historica") setSubIH(nextSub);
    if (requestedSection === "datos_geologicos") setSubDG(nextSub);
    if (requestedSection === "multimedia") setSubMM(nextSub);
  }, [searchParams, evento]);

  const navSections = useMemo(
    () => getEventoNavSectionsWithContent(evento, EVENTO_NAV_SECTIONS),
    [evento],
  );

  useEffect(() => {
    if (!evento || navSections.length === 0) return;

    const sectionKeys = new Set(navSections.map((s) => s.key));
    if (!sectionKeys.has(mainTab)) {
      const first = navSections[0];
      setMainTab(first.key);
      if (Array.isArray(first.children) && first.children.length > 0) {
        const firstChild = first.children[0].key;
        if (first.key === "informacion_historica") setSubIH(firstChild);
        if (first.key === "datos_geologicos") setSubDG(firstChild);
        if (first.key === "multimedia") setSubMM(firstChild);
      }
      return;
    }

    const section = navSections.find((s) => s.key === mainTab);
    const children = Array.isArray(section?.children) ? section.children : [];
    if (children.length === 0) return;

    const childKeys = new Set(children.map((c) => c.key));
    const currentSub =
      mainTab === "informacion_historica"
        ? subIH
        : mainTab === "datos_geologicos"
          ? subDG
          : mainTab === "multimedia"
            ? subMM
            : null;
    if (currentSub && childKeys.has(currentSub)) return;

    const preferred = defaultSubForEventoSection(mainTab);
    const nextSub = childKeys.has(preferred) ? preferred : children[0]?.key;
    if (!nextSub) return;

    if (mainTab === "informacion_historica") setSubIH(nextSub);
    if (mainTab === "datos_geologicos") setSubDG(nextSub);
    if (mainTab === "multimedia") setSubMM(nextSub);
  }, [evento, navSections, mainTab, subIH, subDG, subMM]);

  useEffect(() => {
    if (!volcanId || !eventoId) {
      setError("Faltan parámetros para cargar el evento.");
      setLoading(false);
      return;
    }

    let mounted = true;
    async function load() {
      try {
        setLoading(true);
        setError(null);
        setTimelineMeta(null);

        const [desc, det, timelineResp] = await Promise.all([
          getVolcanDescripcionById(volcanId),
          getEventoDetalleAmpliado(volcanId, eventoId),
          getLineaTiempoPorVolcan(volcanId),
        ]);

        if (!mounted) return;
        const title =
          desc?.title ?? desc?.volcan?.title ?? desc?.volcan_title ?? "";
        setVolcanTitle(title);
        setEvento(det);

        const timelineList = Array.isArray(timelineResp)
          ? timelineResp
          : (timelineResp?.results ?? []);
        const fromTimeline = timelineList.find(
          (e) => String(e?.id) === String(eventoId),
        );
        setTimelineMeta(fromTimeline ?? null);
        const evtTitle = String(
          det?.title ??
            det?.titulo ??
            fromTimeline?.title ??
            fromTimeline?.titulo ??
            "",
        ).trim();
        setEventoTitle(evtTitle);
      } catch {
        if (!mounted) return;
        setError("No se pudo cargar la información del evento.");
      } finally {
        if (!mounted) return;
        setLoading(false);
      }
    }

    load();
    return () => {
      mounted = false;
    };
  }, [volcanId, eventoId]);

  if (loading) {
    return (
      <div className="volcan-detail volcan-detail--solo-mensaje">
        <p>Cargando...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="volcan-detail volcan-detail--solo-mensaje">
        <p>{error}</p>
      </div>
    );
  }

  if (!evento) {
    return (
      <div className="volcan-detail volcan-detail--solo-mensaje">
        <p>No existe el evento</p>
      </div>
    );
  }

  const eventoImagenPath = pickEventoImagenPath(timelineMeta, evento);
  const eventoImagenUrl = eventoImagenPath ? getMediaUrl(eventoImagenPath) : "";
  const fechaResumen = formatFechaEventoResumen(timelineMeta ?? evento);
  const eventoTituloResumen = getEventoTituloSinPrefijoFecha(eventoTitle);
  const tipoKey = timelineMeta?.tipo ?? evento?.tipo ?? "";
  const tipoMasthead = (() => {
    if (tipoKey && EVENTO_TIPO_LINEA_LABEL[tipoKey]) {
      return EVENTO_TIPO_LINEA_LABEL[tipoKey];
    }
    return tipoKey ? String(tipoKey) : tipoEventoParaMasthead(evento);
  })();
  const tipoColor = EVENTO_TIPO_COLORS[tipoKey] || "#C8C8C8";
  const tipoTextColor = eventoTipoBadgeTextColor(tipoKey);

  return (
    <div className="volcan-detail">
      <div className="volcan-layout">
        <VolcanSidebar
          activeTab={activeTab}
          setActiveTab={(tabKey) => {
            const volcan = volcanId ? Number(volcanId) : null;
            if (!volcan) return;
            navigate(`/volcan-detalle?id=${volcan}&tab=${tabKey}`);
          }}
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />

        <div
          className={`volcan-content ${sidebarOpen ? "expanded" : "collapsed"}`}
        >
          <div className="volcan-body-scroll evt-page">
            <div className="evt-top-mask" aria-hidden="true" />
            <div className="volcan-title volcan-title--sticky evt-volcan-title--evento">
              <div className="evt-volcan-title-row">
                <div className="evt-back-to-timeline-wrap">
                  <Link
                    className="evt-back-to-timeline"
                    to={`/volcan-detalle?id=${volcanId}&tab=timeline&timelineEvent=${eventoId}`}
                    data-sgc-tooltip="Volver a la línea de tiempo"
                    data-sgc-tooltip-pos="right"
                    aria-label="Volver a la línea de tiempo"
                  >
                    <i className="bi bi-arrow-left" aria-hidden />
                    <span>Volver</span>
                  </Link>
                </div>
                <h2>{volcanTitle || "—"}</h2>
                <div className="evt-volcan-title-spacer" aria-hidden="true" />
              </div>
            </div>

            <div className="volcan-body-inner evt-event-body-inner">
              <section
                className="evt-summary-card"
                aria-label="Resumen del evento"
              >
                <div className="evt-summary-card__media">
                  {eventoImagenUrl ? (
                    <img
                      src={eventoImagenUrl}
                      alt={eventoTitle || "Imagen del evento"}
                      className="evt-summary-card__image"
                    />
                  ) : (
                    <div className="evt-summary-card__placeholder" aria-hidden>
                      <i className="bi bi-image" />
                      <span>Sin imagen</span>
                    </div>
                  )}
                </div>

                <div className="evt-summary-card__body">
                  <span
                    className="evt-summary-card__tipo"
                    style={{
                      backgroundColor: tipoColor,
                      color: tipoTextColor,
                    }}
                  >
                    {tipoMasthead}
                  </span>
                  <div className="evt-summary-card__fecha">{fechaResumen}</div>
                  <h1 className="evt-summary-card__title" title={eventoTitle}>
                    {eventoTituloResumen || "—"}
                  </h1>
                </div>
              </section>

              <EventoTopNav
                mainTab={mainTab}
                setMainTab={setMainTab}
                subIH={subIH}
                setSubIH={setSubIH}
                subDG={subDG}
                setSubDG={setSubDG}
                subMM={subMM}
                setSubMM={setSubMM}
                volcanId={volcanId}
                eventoId={eventoId}
                sections={navSections}
              />

              {mainTab === "generalidades" ? (
                <>
                  <PanelGeneralidades evento={evento} />
                </>
              ) : null}
              {mainTab === "informacion_historica" ? (
                <PanelInformacionHistorica
                  evento={evento}
                  subTab={subIH}
                  volcanTitle={volcanTitle}
                  eventoTitle={eventoTitle}
                />
              ) : null}
              {mainTab === "datos_geologicos" ? (
                <PanelDatosGeologicos
                  evento={evento}
                  subTab={subDG}
                  volcanTitle={volcanTitle}
                  eventoTitle={eventoTitle}
                />
              ) : null}
              {mainTab === "multimedia" ? (
                <PanelMultimedia evento={evento} subTab={subMM} />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
